// Types
import Reducers from "app/types/Reducers";
// Actions
import { AppUiNotificationsActions } from "../AppUINotifications/AppUINotifications.slice";
// Messages
import Messages from "./CalendarEventTypes.messages";
// Utilities
import asyncThunkHandler from "app/utilities/AsyncThunkHandler";
import { $delete, $get, $post, $put } from 'app/utilities/HttpClient';

const _url:string = '/calendarEventTypes';

export const getCalendarEventTypes = asyncThunkHandler(
  `${Reducers.CalendarEventTypes}/Get calendar event types`,
  async (params) => {
    const response:Response = await $get(_url, params);
    return response.json();
  }
);

export const getCalendarEventType = asyncThunkHandler(
  `${Reducers.CalendarEventTypes}/Get calendar event type`,
  async (eventTypeId:number) => {
    const response:Response = await $get(`${_url}/${eventTypeId}`);
    return response.json();
  }
);

export const createCalendarEventType = asyncThunkHandler(
  `${Reducers.CalendarEventTypes}/Create calendar event type`,
  async (data:any, { dispatch }) => {
    const response:Response = await $post(_url, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Create
    }));
    return response.json();
  }
);

export const updateCalendarEventType = asyncThunkHandler(
  `${Reducers.CalendarEventTypes}/Update calendar event type`,
  async ({ eventTypeId, data }:{ eventTypeId:number, data:any }, { dispatch }) => {
    const response:Response = await $put(`${_url}/${eventTypeId}`, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Update
    }));
    return response.json();
  }
);

export const deleteCalendarEventType = asyncThunkHandler(
  `${Reducers.CalendarEventTypes}/Delete calendar event type`,
  async (eventTypeId:number, { fulfillWithValue, dispatch }) => {
    await $delete(`${_url}/${eventTypeId}`);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Delete
    }));
    return fulfillWithValue(eventTypeId);
  }
);
